import { render } from "./Champ_Telephone.vue?vue&type=template&id=3376b851"
import script from "./Champ_Telephone.vue?vue&type=script&lang=js"
export * from "./Champ_Telephone.vue?vue&type=script&lang=js"

import "./Champ_Telephone.vue?vue&type=style&index=0&id=3376b851&lang=scss"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__